module.exports = __webpack_public_path__ + "img/tube2.e92c07bd.png";